import { Box } from '@mui/material';
import { keyframes } from '@emotion/react';
import { visuallyHidden } from '@mui/utils';
import { surfaceShadows } from '../../surfaceStyles';

const emboss = keyframes`
  0%, 8%, 92%, 100% {
    color: var(--qk-muted);
    text-shadow: 0 0 0 transparent, 0 0 0 transparent;
    animation-timing-function: ease-in;
  }
  28%, 72% {
    color: var(--qk-muted);
    text-shadow: var(--qk-raised-shadow);
    animation-timing-function: ease-out;
  }
  44%, 56% {
    color: var(--qk-green);
    text-shadow: var(--qk-raised-shadow);
    animation-timing-function: ease-in;
  }
`;

export function AppLoadingScreen() {
  return (
    <Box
      role="status"
      sx={{
        minHeight: '100vh',
        '@supports (height: 100dvh)': { minHeight: '100dvh' },
        display: 'grid',
        placeItems: 'center',
        bgcolor: 'background.default',
      }}
    >
      <Box component="span" sx={visuallyHidden}>
        Loading…
      </Box>
      <Box
        aria-hidden="true"
        sx={(theme) => ({
          '--qk-muted': theme.palette.divider,
          '--qk-green': theme.palette.primary.main,
          '--qk-raised-shadow': surfaceShadows.control,
          color: 'primary.main',
          textShadow: 'var(--qk-raised-shadow)',
          fontSize: 72,
          fontWeight: 750,
          letterSpacing: '-0.045em',
          lineHeight: 1.2,
          animation: `${emboss} 3.5s linear infinite`,
          '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
          },
        })}
      >
        qk
      </Box>
    </Box>
  );
}
